import { ArgumentAxis, Chart, LineSeries, ValueAxis } from "@devexpress/dx-react-chart-material-ui";
import { Box, Paper, Typography } from "@material-ui/core";
import { RequestQueryBuilder } from "@nestjsx/crud-request";
import { format, parse } from "date-fns";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Center } from "../../../../components/center";
import { ErrorPanel } from "../../../../components/error_panel";
import { Loading } from "../../../../components/loading";
import { IAsyncData } from "../../../../core/models";
import { isError, isPending, isSuccess } from "../../../../core/redux";
import { IAppReduxState } from "../../../../redux/store";
import { IProductHistory } from "../../data/entities";
import { productHistoryReduxActions } from "../state/state";

interface IProps {
  productId: string;
}

function productHistoryQuery(productId: string): string {
  const qb = RequestQueryBuilder.create();

  qb.setFilter({
    field: "product",
    operator: "$eq",
    value: productId,
  });

  qb.sortBy({ field: "id", order: "DESC" });

  return qb.query(false);
}

const tickFormat = () => (date: any) => {
  return format(parse(date, "dd MMMM yyyy HH:mm", new Date()), "dd MMM");
};

export const ProductHistoryDetail: React.FC<IProps> = ({ productId }: IProps) => {
  const dispatch = useDispatch();
  // const history = useHistory();

  useEffect(() => {
    const s = productHistoryQuery(productId);
    dispatch(productHistoryReduxActions.getList(`?${s}`));
  }, [dispatch, productId]);
  const productHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IProductHistory[]>>(
    (state) => state.productHistory.list,
  );

  return (
    <Box mt={3}>
      <Loading loading={isPending(productHistoryListBranch)}>
        <Paper>
          {productHistoryListBranch.data && (
            <Chart
              data={productHistoryListBranch.data
                .map((h) => ({
                  ...h,
                  createdDate: format(h.createdDate, "dd MMMM yyyy HH:mm"),
                }))
                .reverse()}
            >
              <ArgumentAxis showGrid showTicks tickFormat={tickFormat} />
              <ValueAxis />
              <LineSeries valueField="priceAfter" argumentField="createdDate" />
            </Chart>
          )}

          {isError(productHistoryListBranch) && (
            <Center>
              <Box py={3}>
                <ErrorPanel branch={productHistoryListBranch} />
              </Box>
            </Center>
          )}

          {isSuccess(productHistoryListBranch) && productHistoryListBranch.data?.length === 0 && (
            <Center>
              <Box py={3}>
                <Typography>Məlumat yoxdur</Typography>
              </Box>
            </Center>
          )}
        </Paper>
      </Loading>
    </Box>
  );
};
